module.exports = __webpack_public_path__ + "media/qrcode.58b8c438.mp4";